package one.healthium.cali.di

import org.koin.dsl.module

internal actual fun composeAppPlatformModule() = module {
}